const MAX_DIMENSION = 1280;
const JPEG_QUALITY = 0.8;

export const getCroppedImg = async (imageSrc, pixelCrop, index) => {
  if (!pixelCrop || ![pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height].every(Number.isFinite) ||
      pixelCrop.width <= 0 || pixelCrop.height <= 0) {
    throw new Error("Please select a valid photo crop.");
  }
  const image = await new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      img.onload = null;
      img.onerror = null;
      resolve(img);
    };
    img.onerror = () => {
      img.onload = null;
      img.onerror = null;
      reject(new Error("Unable to load this photo. Please choose it again."));
    };
    img.src = imageSrc;
  });
  const canvas = document.createElement("canvas");
  try {
    const scale = Math.min(1, MAX_DIMENSION / Math.max(pixelCrop.width, pixelCrop.height));
    canvas.width = Math.max(1, Math.round(pixelCrop.width * scale));
    canvas.height = Math.max(1, Math.round(pixelCrop.height * scale));
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Unable to prepare this photo.");
    // JPEG has no transparency; use white rather than a black background.
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height,
      0, 0, canvas.width, canvas.height);
    const blob = await new Promise((resolve, reject) => {
      canvas.toBlob((result) => {
        if (result) resolve(result);
        else reject(new Error("Unable to prepare this photo. Please try again."));
      }, "image/jpeg", JPEG_QUALITY);
    });
    return new File([blob], `cropped_img_${index}.jpg`, { type: "image/jpeg" });
  } finally {
    canvas.width = 0;
    canvas.height = 0;
  }
};
